module.exports = __webpack_public_path__ + "img/workspace.9b97f135.svg";